<template>
  <svg width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.1599 3.05476C10.0442 1.58883 8.33792 0.757812 6.50036 0.757812C4.6628 0.757812 2.9565 1.58883 1.84084 3.05476C0.243647 5.15483 0.243647 8.06451 1.84084 10.1646L6.50036 16.2458L11.1599 10.1646C12.7571 8.06451 12.7571 5.15483 11.1599 3.05476ZM6.50036 3.40503C8.18453 3.40503 9.56274 4.7832 9.56274 6.46741C9.56274 8.15162 8.18457 9.52979 6.50036 9.52979C4.81615 9.52979 3.43798 8.15162 3.43798 6.46741C3.43798 4.7832 4.81615 3.40503 6.50036 3.40503Z" fill="currentColor" stroke="#7E8490" stroke-width="1.0417" stroke-miterlimit="10" />
  </svg>
</template>

<script>
export default {
  name: 'Location',
};
</script>

<style lang="scss" scoped>
.icon {
  path{
    fill: currentColor;
  }
}
</style>
